<template>
  <tooltip location="bottom">
    <template #toggle>
      <span class="tooltip-toggle">
        <icon icon="info" />
      </span>
    </template>
    <slot name="tooltipText"> Shalom from the tooltip! </slot>
  </tooltip>
</template>
<script setup lang="ts">
import Tooltip from "@/components/shared/Tooltip.vue";
import Icon from "@/components/shared/Icon.vue";
</script>
